import React, { useEffect, useRef, useState } from "react";
import { ELSI_STATIC_URL } from "../../constant";
import { hintsService } from "./hintsService";
import HintItem from "./HintItem";

const HintsList = ({ CustomRouter, isActive, setIsActive, setRestoreHints, setIsLoading }) => {
    const [hintsList, setHintsList] = useState([]);
    const [globalSearchHistory, setGlobalSearchHistory] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const [validImageByKey, setValidImageByKey] = useState({});
    const hintsCache = useRef([]);
    const listRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            hintsService.fetchGlobalSearchHistory();
        };

        fetchData();

        const hintsObserver = (hints) => {
            setHintsList(hints);
            hintsCache.current = hints;
        };

        hintsService.registerHintsObserver(hintsObserver);

        const globalHistoryObserver = (globalHistory) => {
            setGlobalSearchHistory(globalHistory);
            setIsReady(true);
            if (setIsLoading) setIsLoading(false);
        };

        hintsService.registerGlobalHistoryObserver(globalHistoryObserver);

        return () => {
            hintsService.unRegisterHintsObserver(hintsObserver);
            hintsService.unRegisterGlobalHistoryObserver(globalHistoryObserver);
        };
    }, []);

    useEffect(() => {
        if (typeof setRestoreHints === "function") {
            setRestoreHints(() => () => setHintsList(hintsCache.current));
        }
    }, [setRestoreHints]);

    useEffect(() => {
        let isCancelled = false;

        const candidates = (hintsList || [])
            .slice(0, 4)
            .filter((item) => Boolean(item && item.hasImage && item.imageName && item.productId));

        setValidImageByKey({});

        if (candidates.length === 0) return () => { isCancelled = true; };

        const checkImageUrl = (url) =>
            new Promise((resolve) => {
                try {
                    const img = new Image();
                    img.onload = () => resolve(true);
                    img.onerror = () => resolve(false);
                    img.src = url;
                } catch (e) {
                    resolve(false);
                }
            });

        Promise.all(
            candidates.map((item) => {
                const key = `${item.productId}|${item.imageName}`;
                const url = `${ELSI_STATIC_URL}/${item.productId}/${item.imageName}`;
                return checkImageUrl(url).then((isOk) => ({ key, isOk }));
            }),
        ).then((results) => {
            if (isCancelled) return;
            const next = {};
            results.forEach(({ key, isOk }) => {
                next[key] = isOk;
            });
            setValidImageByKey(next);
        });

        return () => {
            isCancelled = true;
        };
    }, [hintsList]);

    const currentSearchValue = hintsService.getSearchValue();

    const handleListClick = (e) => {
        e.stopPropagation();
        setIsActive(true);
    };

    const handleListMouseDown = (e) => {
        e.preventDefault();
    };

    if (!isReady) {
        return null;
    }

    return (
        <ul
            className={`search-options__list chapche-event-scroll ${isActive ? "search-options__list_active" : ""}`}
            ref={listRef}
            onClick={handleListClick}
            onMouseDown={handleListMouseDown}
            tabIndex="-1"
        >
            <li className="search-options__close">
                <button
                    type="button"
                    className="search-options__close-button"
                    aria-label="Close"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsActive(false);
                    }}
                >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1.00001L11 11" stroke="#1C1C1C" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M11 1.00001L1 11" stroke="#1C1C1C" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </li>

            {currentSearchValue.length >= 3 && hintsList.length > 0 && (
                <>
                    {hintsList.map((item, index) => {
                        const key = item?.productId && item?.imageName ? `${item.productId}|${item.imageName}` : `idx|${index}`;
                        const isValid = validImageByKey[key] === true;
                        const imageSrc =
                            isValid && item?.productId && item?.imageName
                                ? `${ELSI_STATIC_URL}/${item.productId}/${item.imageName}`
                                : "http://cdn.auroraelec.ru/static/250px.svg";

                        return (
                            <HintItem
                                key={`${item?.productId || "noid"}-${index}`}
                                productId={item.productId}
                                productPartNumber={item.productPartNumber}
                                productManufacturerId={item.productManufacturerId}
                                productManufacturerName={item.productManufacturerName}
                                productAttributeValue={item.productAttributeValue}
                                productAttributeKey={item.productAttributeKey}
                                packageType={item.packageType}
                                stockQuantity={item.stockQuantity}
                                orderQuantity={item.orderQuantity}
                                description={item.description || item.productDescription || item.shortDescription || item.productShortDescription}
                                categoryName={item.categoryName}
                                imageSrc={imageSrc}
                                CustomRouter={CustomRouter}
                            />
                        );
                    })}
                    <li className="search-options__footer">
                        <span className="search-options__note">Показаны первые {hintsList.length} результата поиска</span>
                        <button
                            onClick={async () => {
                                setIsActive(false);
                                try {
                                    await hintsService.saveSearchHistory(currentSearchValue);
                                    await hintsService.storeSearchQuery(currentSearchValue);
                                    window.location.href = `/search?q=${currentSearchValue}&offset=0&limit=5`;
                                } catch (error) {
                                    console.error("Ошибка при обработке запроса:", error);
                                }
                            }}
                            className="search-options__show-all-button"
                        >
                            Показать все результаты
                        </button>
                    </li>
                </>
            )}
        </ul>
    );
};

export default HintsList;

